import { createMuiTheme } from "@material-ui/core/styles";

// A custom theme for this app
const theme = createMuiTheme({
    palette: {
        type: "light",
        primary: {
            main: "#5D5D5D",
            contrastText: "#ffffff",
        },
        secondary: {
            main: "#E30202"
        },
        info: {
            main: "#0202E3"
        },
        text: {
            primary: "rgba(0, 0, 0, 0.57)"
        },
        background: {
            paper: "#FAFAFA",
            default: "#FAFAFA",
        },
    },
    typography: {
        h5: {
            fontWeight: "bold",
            marginBottom: "16px",
            color: "rgba(0, 0, 0)",
        },
        body1: {
            fontSize: ".95em",
            lineHeight: "1.9em",
        }
    },
    overrides: {
        MuiLink: {
            root: {
                color: "#fff"
            }
        }
    }
});

export default theme;
